import React, { useLayoutEffect, useState, useEffect } from 'react';
import './App.scss';
import history from './utils/brwserHistory';
import { Route, Router, Routes } from 'react-router-dom';
import Spinner from './spinner/Spinner';
import DefaultLayout from './components/defaultLayout/DefaultLayout';
import { initializeFunctionRegistry } from './utils/functionRunnerUtils';
import { initPrebid } from './prebid/initPrebid';

function App() {
    const [state, setState] = useState({
        action: history.action,
        location: history.location
    });

    // Initialize function registry and Prebid on app startup
    useEffect(() => {
        initializeFunctionRegistry();
        
        // Ініціалізація Prebid після завантаження DOM
        const initializePrebid = () => {
            const initialized = initPrebid();
            if (!initialized) {
                console.warn('Prebid initialization failed. Retrying in 1 second...');
                setTimeout(initializePrebid, 1000);
            }
        };
        
        // Невелика затримка щоб переконатися що prebid.js завантажений
        setTimeout(initializePrebid, 100);
    }, []);

    useLayoutEffect(() => history.listen(setState), []);

    return (
        <div className="App">
            <Router navigator={history} location={state.location} navigationType={state.action} basename={'/'}>
                <React.Suspense fallback={<Spinner />}>
                    <Routes>
                        <Route path="/*" element={<DefaultLayout />} />
                    </Routes>
                </React.Suspense>
            </Router>
        </div>
    );
}

export default App;
